<div class="clients-management">
  <div class="header">
    <h2>Client Management</h2>
    <button class="btn btn-primary" (click)="openCreateModal()">
      ➕ Add New Client
    </button>
  </div>

  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>

  <div *ngIf="loading" class="loading">Loading...</div>

  <div *ngIf="!loading && clients.length === 0" class="no-data">
    No clients found. Click "Add New Client" to create one.
  </div>

  <table *ngIf="!loading && clients.length > 0" class="clients-table">
    <thead>
      <tr>
        <th>ID</th>
        <th>Client Name</th>
        <th>Labels</th>
        <th>Description</th>
        <th>Created Date</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let client of clients">
        <td>{{ client.clientParamID }}</td>
        <td>{{ client.clientName }}</td>
        <td>
          <span *ngIf="!client.labels || client.labels.length === 0" class="no-labels">No labels</span>
          <span *ngIf="client.labels && client.labels.length > 0" class="label-list">
            <span class="label-badge" *ngFor="let label of client.labels">{{ label }}</span>
          </span>
        </td>
        <td>{{ client.description || '-' }}</td>
        <td>{{ client.createdDate | date:'short' }}</td>
        <td>
          <span class="status-badge" [class.active]="client.isActive" [class.inactive]="!client.isActive">
            {{ client.isActive ? 'Active' : 'Inactive' }}
          </span>
        </td>
        <td class="actions">
          <button class="btn btn-sm btn-users" (click)="openUsersModal(client)" title="Manage Users">
            👥
          </button>
          <button class="btn btn-sm btn-label" (click)="openLabelModal(client)" title="Manage Labels">
            🏷️
          </button>
          <button class="btn btn-sm btn-edit" (click)="openEditModal(client)" title="Edit">
            ✏️
          </button>
          <button class="btn btn-sm btn-delete" (click)="deleteClient(client)" title="Delete">
            🗑️
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Labels Management Section -->
  <div class="labels-section">
    <div class="section-header" (click)="toggleLabelsSection()">
      <h3>
        <span class="toggle-icon">{{ showLabelsSection ? '▼' : '▶' }}</span>
        Manage Labels
      </h3>
      <span class="label-count">{{ allLabels.length }} labels</span>
    </div>

    <div class="section-content" *ngIf="showLabelsSection">
      <div *ngIf="labelsLoading" class="loading">Loading labels...</div>

      <div *ngIf="!labelsLoading && allLabels.length === 0" class="no-data">
        No labels found. Labels will be created when you assign them to clients.
      </div>

      <div *ngIf="!labelsLoading && allLabels.length > 0" class="labels-list">
        <div class="label-row" *ngFor="let label of allLabels">
          <span class="label-name">{{ label.labelDesc }}</span>
          <span class="label-date">Created: {{ label.createdDate | date:'shortDate' }}</span>
          <button class="btn btn-sm btn-delete" (click)="confirmDeleteLabel(label)" title="Delete Label">
            🗑️
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Label Confirmation Modal -->
  <div class="modal" *ngIf="showDeleteLabelModal" (click)="cancelDeleteLabel()">
    <div class="modal-content delete-confirm-modal" (click)="$event.stopPropagation()">
      <div class="modal-header warning">
        <h3>⚠️ Delete Label</h3>
        <button class="close-btn" (click)="cancelDeleteLabel()">✖</button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete the label "<strong>{{ labelToDelete?.labelDesc }}</strong>"?</p>

        <div *ngIf="labelUsageInfo && labelUsageInfo.clientCount > 0" class="warning-box">
          <p><strong>Warning:</strong> This label is currently assigned to {{ labelUsageInfo.clientCount }} client(s):</p>
          <ul class="affected-clients">
            <li *ngFor="let client of labelUsageInfo.clients">{{ client.clientName }}</li>
          </ul>
          <p>Deleting this label will remove it from all these clients.</p>
        </div>

        <div *ngIf="labelUsageInfo && labelUsageInfo.clientCount === 0" class="info-box">
          <p>This label is not assigned to any clients.</p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cancelDeleteLabel()">Cancel</button>
        <button class="btn btn-danger" (click)="executeDeleteLabel()">Delete Label</button>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal" *ngIf="showModal" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ isEditMode ? 'Edit Client' : 'Add New Client' }}</h3>
        <button class="close-btn" (click)="closeModal()">✖</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="clientName">Client Name *</label>
          <input
            type="text"
            id="clientName"
            [(ngModel)]="currentClient.clientName"
            placeholder="Enter client name"
            required
          />
        </div>
        <div class="form-group">
          <label for="description">Description</label>
          <textarea
            id="description"
            [(ngModel)]="currentClient.description"
            placeholder="Enter description"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              [(ngModel)]="currentClient.isActive"
            />
            Active
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button class="btn btn-primary" (click)="saveClient()">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Label Management Modal -->
  <div class="modal" *ngIf="showLabelModal" (click)="closeLabelModal()">
    <div class="modal-content label-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Manage Labels - {{ selectedClientForLabels?.clientName }}</h3>
        <button class="close-btn" (click)="closeLabelModal()">✖</button>
      </div>
      <div class="modal-body">
        <div class="label-management">
          <!-- Assigned labels as chips -->
          <div class="assigned-labels">
            <span class="label-chip" *ngFor="let label of clientLabels">
              {{ label }}
              <button class="remove-chip" (click)="removeLabel(label)">×</button>
            </span>
            <span *ngIf="clientLabels.length === 0" class="no-labels-text">No labels assigned</span>
          </div>

          <!-- Autocomplete input -->
          <div class="autocomplete-container">
            <input
              type="text"
              class="autocomplete-input"
              [(ngModel)]="labelSearchText"
              (input)="onLabelSearchChange()"
              (focus)="showSuggestions = true"
              (keydown.enter)="addNewLabel($event)"
              placeholder="Type to search or add new label..."
            />

            <!-- Suggestions dropdown -->
            <div class="suggestions-dropdown" *ngIf="showSuggestions && filteredLabels.length > 0">
              <div
                class="suggestion-item"
                *ngFor="let label of filteredLabels"
                (mousedown)="selectLabel(label)"
              >
                {{ label.labelDesc }}
              </div>
            </div>

            <!-- Add new label hint -->
            <div class="add-new-hint" *ngIf="showSuggestions && labelSearchText.trim() && !labelExistsInSuggestions()">
              <div class="suggestion-item new-label" (mousedown)="addNewLabel($event)">
                ➕ Create "{{ labelSearchText.trim() }}"
              </div>
            </div>
          </div>

          <p class="helper-text">
            Select from existing labels or type to create a new one. Press Enter to add.
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="closeLabelModal()">Done</button>
      </div>
    </div>
  </div>

  <!-- Users Management Modal -->
  <div class="modal" *ngIf="showUsersModal" (click)="closeUsersModal()">
    <div class="modal-content users-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Manage Users - {{ selectedClientForUsers?.clientName }}</h3>
        <button class="close-btn" (click)="closeUsersModal()">✖</button>
      </div>
      <div class="modal-body">
        <div class="users-toolbar">
          <button class="btn btn-primary btn-sm" (click)="openCreateUserModal()">
            ➕ Add User
          </button>
        </div>

        <div *ngIf="usersLoading" class="loading">Loading users...</div>

        <div *ngIf="!usersLoading && clientUsers.length === 0" class="no-data">
          No users found. Click "Add User" to create one.
        </div>

        <table *ngIf="!usersLoading && clientUsers.length > 0" class="users-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>Status</th>
              <th>Created</th>
              <th>Last Login</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of clientUsers">
              <td>{{ user.email }}</td>
              <td>{{ user.firstName || '' }} {{ user.lastName || '' }}</td>
              <td>
                <span class="status-badge" [class.active]="user.isPasswordSet" [class.pending]="!user.isPasswordSet">
                  {{ user.isPasswordSet ? 'Active' : 'Pending Setup' }}
                </span>
              </td>
              <td>{{ user.createdDate | date:'short' }}</td>
              <td>{{ user.lastLoginDate ? (user.lastLoginDate | date:'short') : 'Never' }}</td>
              <td class="user-actions">
                <button
                  class="btn btn-sm btn-history"
                  (click)="openLoginHistory(user)"
                  title="View Login History">
                  📋
                </button>
                <button
                  *ngIf="!user.isPasswordSet"
                  class="btn btn-sm btn-resend"
                  (click)="resendSetupEmail(user)"
                  title="Resend Password Setup Email"
                  [disabled]="resendingUserId === user.clientUserID">
                  {{ resendingUserId === user.clientUserID ? '⏳' : '📧' }}
                </button>
                <button class="btn btn-sm btn-delete" (click)="deleteUser(user)" title="Delete">
                  🗑️
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeUsersModal()">Close</button>
      </div>
    </div>
  </div>

  <!-- Create User Modal -->
  <div class="modal" *ngIf="showCreateUserModal" (click)="closeCreateUserModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Add New User</h3>
        <button class="close-btn" (click)="closeCreateUserModal()">✖</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="userEmail">Email *</label>
          <input
            type="email"
            id="userEmail"
            [(ngModel)]="newUser.email"
            placeholder="Enter email address"
            required
          />
        </div>
        <div class="form-group">
          <label for="userFirstName">First Name</label>
          <input
            type="text"
            id="userFirstName"
            [(ngModel)]="newUser.firstName"
            placeholder="Enter first name"
          />
        </div>
        <div class="form-group">
          <label for="userLastName">Last Name</label>
          <input
            type="text"
            id="userLastName"
            [(ngModel)]="newUser.lastName"
            placeholder="Enter last name"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeCreateUserModal()">Cancel</button>
        <button class="btn btn-primary" (click)="createUser()">Create User</button>
      </div>
    </div>
  </div>

  <!-- Login History Modal -->
  <div class="modal" *ngIf="showLoginHistoryModal" (click)="closeLoginHistoryModal()">
    <div class="modal-content modal-lg" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Login History - {{ selectedUserForHistory?.email }}</h3>
        <button class="close-btn" (click)="closeLoginHistoryModal()">✖</button>
      </div>
      <div class="modal-body">
        <div *ngIf="loginHistoryLoading" class="loading">Loading...</div>
        <div *ngIf="!loginHistoryLoading && loginHistory.length === 0" class="no-data">
          No login history found
        </div>
        <table *ngIf="!loginHistoryLoading && loginHistory.length > 0" class="data-table">
          <thead>
            <tr>
              <th>Date/Time</th>
              <th>Status</th>
              <th>IP Address</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let attempt of loginHistory">
              <td>{{ attempt.attemptedAt | date:'medium' }}</td>
              <td>
                <span class="login-status" [ngClass]="getStatusClass(attempt.status)">
                  {{ getStatusLabel(attempt.status) }}
                </span>
              </td>
              <td>{{ attempt.ipAddress || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeLoginHistoryModal()">Close</button>
      </div>
    </div>
  </div>
</div>
